import { useState } from 'react';
import PropTypes from 'prop-types';
import { IoCheckmark, IoChevronDownOutline } from 'react-icons/io5';
import ReadingSheet from '../reading/ReadingSheet';
import { describeReaders } from '../../utils/logSubmit';
import './ReaderPickerSheet.css';

/**
 * "For: Brandon ▾" — one line that opens a sheet with Just me, each family,
 * and individual readers. Replaces the four-tab reader card on the log page.
 */
const ReaderPickerSheet = ({
  readers,
  families,
  readerMode,
  selectedReaders,
  selectedFamily,
  onPickMe,
  onPickFamily,
  onToggleReader
}) => {
  const [open, setOpen] = useState(false);
  const primary = readers.find(r => r.isPrimary);
  const isSelected = (reader) => selectedReaders.some(r => r.id === reader.id);

  return (
    <>
      <button type="button" className="reader-row" onClick={() => setOpen(true)} aria-haspopup="dialog">
        <span className="reader-row-label">For</span>
        <span className="reader-row-value">
          {describeReaders({ readerMode, selectedFamily, selectedReaders })}
        </span>
        <IoChevronDownOutline size={16} aria-hidden="true" />
      </button>

      <ReadingSheet open={open} onClose={() => setOpen(false)} title="Who read?">
        {primary && (
          <button
            type="button"
            className={`reader-option ${readerMode === 'primary' ? 'selected' : ''}`}
            onClick={() => { onPickMe(); setOpen(false); }}
          >
            <span>Just me <small>({primary.name})</small></span>
            {readerMode === 'primary' && <IoCheckmark size={18} aria-hidden="true" />}
          </button>
        )}

        {families.length > 0 && (
          <section>
            <h3 className="reader-group-title">Whole family</h3>
            {families.map(family => (
              <button
                key={family.id}
                type="button"
                className={`reader-option ${readerMode === 'family' && selectedFamily?.id === family.id ? 'selected' : ''}`}
                onClick={() => { onPickFamily(family); setOpen(false); }}
              >
                <span>{family.name} <small>({family.readers?.length || 0} readers)</small></span>
                {readerMode === 'family' && selectedFamily?.id === family.id && (
                  <IoCheckmark size={18} aria-hidden="true" />
                )}
              </button>
            ))}
          </section>
        )}

        {readers.length > 1 && (
          <section>
            <h3 className="reader-group-title">Pick readers</h3>
            {readers.map(reader => (
              <label key={reader.id} className="reader-option reader-check">
                <input
                  type="checkbox"
                  checked={readerMode === 'specific' && isSelected(reader)}
                  onChange={() => onToggleReader(reader)}
                />
                <span>{reader.name}{reader.isPrimary && <small> (you)</small>}</span>
              </label>
            ))}
            <button type="button" className="reader-done" onClick={() => setOpen(false)}>Done</button>
          </section>
        )}
      </ReadingSheet>
    </>
  );
};

ReaderPickerSheet.propTypes = {
  readers: PropTypes.array.isRequired,
  families: PropTypes.array.isRequired,
  readerMode: PropTypes.oneOf(['primary', 'family', 'specific']).isRequired,
  selectedReaders: PropTypes.array.isRequired,
  selectedFamily: PropTypes.object,
  onPickMe: PropTypes.func.isRequired,
  onPickFamily: PropTypes.func.isRequired,
  onToggleReader: PropTypes.func.isRequired
};

export default ReaderPickerSheet;
